export class BookmarkInfo {
    name: string;
    visibleIndex: number;
}
